import { LoadingView } from "@app/components/Loading";
import TableListPaging from "@app/components/TableListPaging";
import { DEFAULT_PAGE_SIZE, ODER_BY_TYPE, ORDER_BY } from "@app/constants/Common";
import { DVTJCUVCddOpenAndNotSddvParentTabs } from "@pages/dvtjcuv/common/CddOpenAndNotSddvTabs";
import { DVTJCUVConnectCddEmpParentTabs } from "@pages/dvtjcuv/common/ConnectCddEmpTabs";
import { DVTJCUVPipelineTableColumns } from "@pages/dvtjcuv/common/Constant";
import UpdateDVTJCUVPipelineModal from "@pages/dvtjcuv/edit/UpdateDVTJCUVPipelineModal";
import DVTJCUVPipelineTableList from "@pages/dvtjcuv/list/DVTJCUVPipelineTableList";
import AdvanceSearchPipelineModal from "@pages/dvtjcuv/list/advancesearch/AdvanceSearchPipelineModal";
import HeaderSearchButtons from "@pages/dvtjcuv/rundvtjcuv/HeaderSearchButtons";
import InputCddGPEmpDiscussionModal from "@pages/dvtjcuv/rundvtjcuv/connectcddemp/InputCddGPEmpDiscussionModal";
import { requestGetDVTJCUVPipeLineList } from "@pages/dvtjcuv/service/DVTJCUVPipelineService";
import SettingHideColumnsModal from "@pages/jobpipeline/list/SettingHideColumnsModal";
import { cloneDeep } from "lodash";
import React, { useEffect, useState } from 'react';
import Button from "react-bootstrap/Button";
import { showMessage } from "@app/constants/Messages";


const InitSearch = {
    search_conditions: {
    },
    // mỗi phần tử gồm key column, loại sort
    sort_columns: {
        created_date_time: ORDER_BY.DESC_UPDATE_DATE
    },
}

const DVTJCUVPipelineList = (props) => {
    const [pipeLineList, setPipeLineList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [selectRow, setSelectRow] = useState(null);
    const [showSearchModal, setShowSearchModal] = useState(false);
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [showBtnAddPipelineOnRefereeInput, setShowBtnAddPipelineOnRefereeInput] = useState(false);
    const [showHideColumnSettingModal, setShowHideColumnSettingModal] = useState(false);
    const [totalCount, setTotalCount] = useState(0);
    const [numberPages, setNumberPages] = useState(1);
    const [viewMode, setViewMode] = useState("1");
    const [hideColumns, setHideColumns] = useState({});
    const [searchInput, setSearchInput] = useState(InitSearch);
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [pipelineInfo, setPipelineInfo] = useState({});
    const [latestPipeline, setLatestPipeline] = useState({});
    const [showInputCddGPEmpDiscussionModal, setShowInputCddGPEmpDiscussionModal] = useState(false);

    const [showBtnSearchCdd, setShowBtnSearchCdd] = useState(true);
    const [showBtnSearchReceiver, setShowBtnSearchReceiver] = useState(true);
    const [showBtnSearchEmployer, setShowBtnSearchEmployer] = useState(true);
    
    let pipelineId = "";
    let cddId = "";
    let recId = "";
    let employerId = "";
    let parentTabId = "";
    let cddEmpProcess = "";
    // let maxStep = "";
    let tabId = "";
    let onlyShowlatestPipeline = "";
    let pipelineHistory = "";
    let mode = "";
    let feedback = "";
    let unlimited = false;
    if (props.location && props.location.search) {
        pipelineId = new URLSearchParams(props.location.search).get("id")
        cddId = new URLSearchParams(props.location.search).get("cddId")
        cddEmpProcess = new URLSearchParams(props.location.search).get("cddEmpProcess")
        recId = new URLSearchParams(props.location.search).get("recId")
        // maxStep = new URLSearchParams(props.location.search).get("maxStep")
        employerId = new URLSearchParams(props.location.search).get("employerId")
        parentTabId = new URLSearchParams(props.location.search).get("parentTabId")
        tabId = new URLSearchParams(props.location.search).get("tabId")
        onlyShowlatestPipeline = new URLSearchParams(props.location.search).get("onlyShowlatestPipeline")
        pipelineHistory = new URLSearchParams(props.location.search).get("pipelineHistory")
        feedback = new URLSearchParams(props.location.search).get("feedback")
        mode = new URLSearchParams(props.location.search).get("mode")
        unlimited = new URLSearchParams(props.location.search).get("unlimited")
    }

    const {runJobMode, jobId, pTab, sTab, runJob, showFullSearch} = props

    useEffect(() => {
        searchInput.search_conditions.cddId = cddId
        searchInput.search_conditions.disable_cdd_id = !!cddId
        searchInput.search_conditions.onlyShowlatestPipeline = !!onlyShowlatestPipeline
        setSearchInput(cloneDeep(searchInput))
    }, [cddId, onlyShowlatestPipeline]) 

    useEffect(() => {
        if (mode === 'search-pipeline') {
            setShowBtnSearchCdd(false)
            setShowBtnSearchReceiver(false)
            setShowBtnSearchEmployer(false)
        }
    }, [mode])

    const searchPipeLines = async (conditions) => {
        console.log("Search conditions:" + JSON.stringify(conditions))
        if (conditions) {
            searchInput.search_conditions = {...conditions}
            searchInput.search_conditions.run_job_mode = runJobMode
            
            // searchInput.search_conditions.run_job_id = runJob ? runJob.id : runJob.id
            // searchInput.search_conditions.parent_tab = pTab ? pTab.id : ""
            // searchInput.search_conditions.sub_tab = sTab ? sTab.id : ""
            // if (runJobMode) {
            //     let cons = searchInput.search_conditions
            //     if (pTab && pTab.id === RunJobParentTabIds.FOLLOW_UP_USER_CDD_DISCUSSION) {
            //         if (sTab?.id === FollowUpUserCddDiscussionTabIds.NOT_CATEGORY) {
            //             cons.cdd_status = CddStatus.UV_EMAIL_REPLY
            //             cons.todo_with_person = TodoWithPersons.DONE_PERIOD_BEFORE_SENDING
            //         } else if (sTab?.id === FollowUpUserCddDiscussionTabIds.TO_SEND) {
            //             cons.internal_process = ProcessJobInternalProcess.WaitingSend
            //             cons.todo_with_person = TodoWithPersons.DONE_PERIOD_BEFORE_SENDING
            //         }
            //     }
            //
            //
            //     searchInput.search_conditions.job_id = jobId
            // }

        }

        searchInput.search_conditions.feedback = feedback
        searchInput.search_conditions.unlimited = !!unlimited
        if (cddId) {
            searchInput.search_conditions.cdd_id = cddId
            searchInput.search_conditions.disable_cdd_id = true
        } else {
            searchInput.search_conditions.disable_cdd_id = false
        }

        if (onlyShowlatestPipeline) {
            searchInput.search_conditions.onlyShowlatestPipeline = true
        }

        if (employerId) {
            searchInput.search_conditions.employer_id = employerId
        }
        if (recId) {
            searchInput.search_conditions.cdd_receiver_id = recId
        }
        if (cddEmpProcess) {
            searchInput.search_conditions.cdd_emp_processes = cddEmpProcess
        }
        // if (maxStep) {
        //     searchInput.search_conditions.maxStep = true
        // }
        if (parentTabId) {
            searchInput.search_conditions.parent_tab = parentTabId
            // Trường hợp search pipeline của tab Brief sent từ ConnectCddEmpContent
            if (parentTabId === DVTJCUVConnectCddEmpParentTabs.BRIEF_SENT_TAB.id) {
                searchInput.search_conditions.cdd_emp_process = {value: 'Brief sent', label: 'Brief sent'}
                searchInput.search_conditions.pipe_has_use_times_max_of_cdd = true
            }
            // Trường hợp search pipeline của tab Brief sent từ CddOpenAndNotSddvContent
            if (parentTabId === DVTJCUVCddOpenAndNotSddvParentTabs.BRIEF_SENT_TAB.id) {
                searchInput.search_conditions.cdd_emp_process = {value: 'Brief sent', label: 'Brief sent'}
                searchInput.search_conditions.pipe_has_use_times_max_of_cdd = true
            }
        }
        if (tabId) {
            searchInput.search_conditions.sub_tab = tabId
        }

        setSearchInput({...searchInput})

        setShowSearchModal(false)
        setIsLoading(true)

        const res = await requestGetDVTJCUVPipeLineList(searchInput);

        setIsLoading(false)
        const resContent = res.content
        setTotalCount(resContent.totalCount)
        const items = resContent.pipelines.map((item, index) => {
            item.no = (resContent.page - 1) * DEFAULT_PAGE_SIZE + index + 1
            return item
        });
        setPipeLineList(items);
        setNumberPages(Math.ceil(resContent.totalCount / DEFAULT_PAGE_SIZE))

        const allIds = resContent.all_pipeline_ids
        if (allIds.length > 0) {
            // Get max id from array allIds
            const maxId = Math.max(...allIds)
            console.log("Max id:", maxId)
            const resLatestPipelines = await requestGetDVTJCUVPipeLineList({
                search_conditions: {
                    id: maxId
                }
            });
            setLatestPipeline(resLatestPipelines.content.pipelines[0])
        }
    }

    const onSort = async (columnKey) => {
        let sortColumns = searchInput.sort_columns
        if (sortColumns[columnKey] && sortColumns[columnKey] === ODER_BY_TYPE.ASC) {
            sortColumns[columnKey] = ODER_BY_TYPE.DESC
        } else {
            sortColumns = {}
            sortColumns[columnKey] = ODER_BY_TYPE.ASC
        }

        searchInput.sort_columns = sortColumns

        await searchPipeLines()
    }

    useEffect(() => {
        if (pipelineId) {
            searchInput.search_conditions.id = pipelineId
        }
        searchInput.search_conditions.job_id = jobId
        searchInput.search_conditions.run_job_mode = runJobMode

        setSearchInput({...searchInput})

        // onSort('created_date_time')
        searchPipeLines()
    }, [jobId, runJobMode, pTab, sTab]);

    // const onChangeOrderBy = async (event) => {
    //     searchInput.search_conditions.order_by = event.target.value
    //     setSearchInput({...searchInput})
    //     await searchPipeLines(searchInput)
    // }

    const onCloseUpdatePipeLine = async (reload) => {
        setShowUpdateModal(false)

        // Xử lý ẩn hiện button add pipeline trên màn hình input referee.
        setShowBtnAddPipelineOnRefereeInput(!reload)

        if (reload) {
            await searchPipeLines()
        }
    }

    const nextPage = async () => {
        let currPage = currentPage + 1
        if (currPage <= numberPages) {
            searchInput.search_conditions.page = currPage
            await searchPipeLines()
        } else {
            currPage = numberPages
        }
        setCurrentPage(currPage)
    };

    const backPage = async () => {
        let currPage = currentPage - 1
        if (currPage > 0) {
            searchInput.search_conditions.page = currPage
            await searchPipeLines()
        } else {
            currPage = 0
        }
        setCurrentPage(currPage)
    };

    const onSaveHideColumnsSettings = (settings) => {
        setShowHideColumnSettingModal(false)
        setHideColumns({...settings})
    }

    const onShowEditItem = (item, fromReferee) => {
        item.fromReferee = !!fromReferee
        setSelectRow({...item})
        setShowUpdateModal(true)
    }

    const onAddItem = () => {
        setSelectRow({cdd_id: cddId})
        setShowUpdateModal(true)
    }

    const onInputGPEmpDiscussion = (dPipeline) => {
        if (pipelineHistory && dPipeline) {
            // Vì dòng pipeline history của 1 receiver có nhiều nên ko cần cdd_id
            dPipeline.cdd_id = cddId
            dPipeline.cdd_receiver_id = recId
            setPipelineInfo(dPipeline)
        } else {
            if (cddId) {
                pipelineInfo.cdd_id = cddId
            }
    
            if (recId && pipelineHistory) {
                pipelineInfo.cdd_receiver_id = recId
            }
    
            else if (onlyShowlatestPipeline && pipeLineList.length > 0) {
                pipelineInfo.cdd_receiver_id = pipeLineList[0].cdd_receiver_id
            }
            setPipelineInfo(pipelineInfo)
        }

        setShowInputCddGPEmpDiscussionModal(true)
    }

    const onChangeViewMode = async (event) => {
        setViewMode(event.target.value)
        searchInput.search_conditions.view_mode = event.target.value
        await searchPipeLines()
    }

    const setScreenTitle = () => {
        if (pipelineHistory) {
            return "Pipeline History"
        }
        if (onlyShowlatestPipeline) {
            return "Latest Pipeline"
        }

        return "Kho DVTJCUV Pipeline"
    }
    
    return (
        <div className="container-fluid">
            <div className="card card-default">
                <div className="card-header">
                    <h3 className='card-title text-bold'>{setScreenTitle()}</h3>
                    <div className='card-tools row'>
                        <a href='#'
                           className='btn btn-default btn-sm mr-2'
                           onClick={() => {
                               setShowSearchModal(true)
                           }}>
                            {/* <i className='fas fa-filter mr-2'/> */}
                            Search pipeline
                        </a>
                        <HeaderSearchButtons
                            // showBtnSearchPipeline
                            showBtnSearchCdd={showBtnSearchCdd}
                            showBtnSearchReceiver={showBtnSearchReceiver}
                            showBtnSearchEmployer={showBtnSearchEmployer}
                        />
                        {pipelineHistory &&
                        <Button onClick={() => onInputGPEmpDiscussion({...latestPipeline})}
                             className={'btn btn-primary btn-sm ml-3'}>
                            Nhập Cdd-GP-Emp Discussion
                        </Button>
                        }
                    </div>
                </div>
                <div className='card-body p-2'>
                    <div className="card card-default">
                        <div className="card-header">
                            <h3 className="card-title text-bold mt-2">Pipelines ({totalCount})</h3>
                            {totalCount > 0 && !unlimited &&
                            <h3 className='card-title text-bold ml-3 mt-2'>Page: {currentPage}/{numberPages}</h3>
                            }
                            <div className="btn-group ml-3">
                                <button type="button" className="btn btn-default">Actions</button>
                                <button type="button" className="btn btn-default dropdown-toggle dropdown-icon"
                                        data-toggle="dropdown">
                                    <span className="sr-only">Toggle Dropdown</span>
                                </button>
                                <div className="dropdown-menu" role="menu">
                                    <button type={"button"}
                                            onClick={onAddItem}
                                            className={'dropdown-item'}>Tạo mới Pipeline
                                    </button>
                                    <button type={"button"}
                                            onClick={() => {
                                                setShowHideColumnSettingModal(true)
                                            }}
                                            className={'dropdown-item'}>Settings
                                    </button>
                                    {userLoginInfo.is_superuser &&
                                    <button type={"button"}
                                            onClick={() => {
                                            }}
                                            className={'dropdown-item'}>Xoá Pipeline
                                    </button>
                                    }
                                    {/*<button type={"button"}*/}
                                    {/*        onClick={() => {}}*/}
                                    {/*        className={'dropdown-item'}>Chỉnh sửa Job Pipeline*/}
                                    {/*</button>*/}
                                    {/*<button type={"button"}*/}
                                    {/*        onClick={() => {}}*/}
                                    {/*        className={'dropdown-item'}>Ư X \
                                    'Job Pipeline*/}
                                    {/*</button>*/}
                                </div>
                            </div>
                            <div className={'card-tools'}>
                                {/*<button type={"button"}*/}
                                {/*        className='btn btn-success'*/}
                                {/*        onClick={() => {*/}

                                {/*        }}>*/}
                                {/*    Add Job Pipeline*/}
                                {/*</button>*/}
                                {/*{totalCount > 0 &&*/}
                                <select className='ml-3'
                                        style={{
                                            padding: '0.375rem 0.75rem',
                                            backgroundColor: '#fff',
                                            border: '1px solid #ced4da',
                                            borderRadius: '0.25rem',
                                            boxShadow: 'inset 0 0 0 transparent',
                                            transition: 'border-color .15s ease-in-out,box-shadow .15s ease-in-out'
                                        }}
                                        name={'view_mode'}
                                        value={viewMode}
                                        onChange={event => onChangeViewMode(event)}>
                                    <option value='1'>All Pipelines</option>
                                    <option value='2'>Latest Pipeline (Cdd-Receiver)</option>
                                    <option value='3'>Latest Pipeline (Cdd-Employer)</option>
                                    <option value='4'>Latest Pipeline (Cdd-Receiver-Process)</option>
                                    <option value='5'>Latest Pipeline (Cdd-Employer-Process)</option>
                                </select>
                                {/*}*/}
                                {numberPages > 1 &&
                                <TableListPaging onBack={backPage} onNext={nextPage}/>
                                }

                                {
                                    cddId && !pipelineHistory &&
                                    <Button variant='info' onClick={() => onInputGPEmpDiscussion()} className={'btn-sm ml-3'}>
                                        Nhập Cdd-GP-Emp Discussion
                                    </Button>

                                }
                            </div>
                            {isLoading &&
                            <LoadingView />
                            }
                        </div>
                        <div className="card-body p-0">
                            <DVTJCUVPipelineTableList pipeLines={pipeLineList}
                                                      hideColumns={hideColumns}
                                                      showBtnAddPipelineOnRefereeInput={showBtnAddPipelineOnRefereeInput}
                                                      onSort={onSort}
                                                      mode={Number(mode)}
                                                      sortColumn={searchInput.sort_columns}
                                                      onEditItem={(selectItem, fromReferee) => onShowEditItem(selectItem, fromReferee)}
                                                      onClose={(reload) => onCloseUpdatePipeLine(reload)}/>
                        </div>
                    </div>
                </div>
            </div>
            <UpdateDVTJCUVPipelineModal isShow={showUpdateModal}
                                    pipeLineInfo={selectRow}
                                    onClose={(reload) => onCloseUpdatePipeLine(reload)}
            />
            <SettingHideColumnsModal isShow={showHideColumnSettingModal}
                                     columns={DVTJCUVPipelineTableColumns}
                                     onSave={(settings) => {
                                         onSaveHideColumnsSettings(settings)
                                     }}
                                     onClose={() => setShowHideColumnSettingModal(false)}
            />

            <AdvanceSearchPipelineModal
                isShow={showSearchModal}
                onClose={() => setShowSearchModal(false)}
                showFullSearch={!!showFullSearch}
                searchInput={searchInput.search_conditions}
                cddId={cddId}
                onSearch={(conditions) => searchPipeLines(conditions)}/>

            {showInputCddGPEmpDiscussionModal &&
                <InputCddGPEmpDiscussionModal
                    pipelineInfo={pipelineInfo}
                    onClose={(success) => {
                        if (success) {
                            showMessage("Đã lưu Cdd-GP-Emp Discussion thành công.", false, true);
                        }
                        setShowInputCddGPEmpDiscussionModal(false);
                    }}
                    isShow={showInputCddGPEmpDiscussionModal} />
            }
        </div>
    );
};

export default DVTJCUVPipelineList;
